import { useState, useEffect } from "react";
import "../styles/ProfilePage.css";
import { IoMdClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile, updateUserProfile } from "../redux/profileSlice";
import API from "../../../../app/api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useLocation } from "react-router-dom";
import { CircleCheckBig, Link, X } from "lucide-react";
import { ToastContainer } from "react-toastify";
import toast from 'react-hot-toast';
// import ProfileBreadcrumbs from "../../../../components/Breadcrumbs/ProfileBreadcrumbs";
import Footer from "../../../../components/Footer/Footer";
import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import profilepic from "../../../../assets/images/profile-pic.svg";

const ProfilePage = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const savedTab = localStorage.getItem("activeTab");
  const [activeTab, setActiveTab] = useState(savedTab || "profile");
  const [showEditModal, setShowEditModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSession, setOtpSession] = useState(null);
  const [dob, setDob] = useState("");
  const [localLoading, setLocalLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [otpTimer, setOtpTimer] = useState(20);
  const [canResendOtp, setCanResendOtp] = useState(false);

  // const activeTab = location.pathname.split("/").pop();
  /* ---------------- TAB STATE (URL SYNC) ---------------- */

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("tab") || "profile";
    setActiveTab(tab);
  }, [location.search]);



  const [editForm, setEditForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    mobile: "",
    dob: "",
  });

  useEffect(() => {
    if (
      showEditModal ||
      showOtpModal   // added this
    ) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [
    showEditModal,
    showOtpModal   // added this
  ]);

  const { data: profileData } = useSelector((state) => state.profile);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (profileData && Object.keys(profileData).length > 0) {
      setLocalLoading(false);
    }
  }, [profileData]);

  useEffect(() => {
    let timer;

    if (showOtpModal && otpTimer > 0) {
      timer = setTimeout(() => {
        setOtpTimer((prev) => prev - 1);
      }, 1000);
    }

    if (otpTimer === 0) {
      setCanResendOtp(true);
    }

    return () => clearTimeout(timer);
  }, [showOtpModal, otpTimer]);


  // Send OTP API
  const handleSendOtp = async () => {
    try {
      const res = await API.post("/email/send-otp", {
        email: profileData?.email,
      });

      if (res.data.status === "success") {
        setOtpSession(res.data.data);
        toast.success("OTP sent successfully!");
        setShowOtpModal(true);

        // reset timer
        setOtpTimer(20);
        setCanResendOtp(false);
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to send OTP");
    }
  };

  // Verify OTP API
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    if (otp.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    try {
      const res = await API.post("/email/verify-otp", {
        otp,
        otp_requested_id: otpSession?.otp_requested_id,
        temp_id: otpSession?.temp_id,
      });

      if (res.data.success) {
        toast.success(res.data.msg || "Verified successfully!", {
          style: {
            border: "1px solid black",
            padding: "16px",
            color: "black",

          },
          iconTheme: {
            primary: "black",
            secondary: "white",
          },
        });
        setShowOtpModal(false);
        setOtp("");
        dispatch(fetchUserProfile());
      }
    } catch (err) {
      console.log(err, "error");
      toast.error(err.response?.msg || "OTP verification failed", {
        style: {
          border: "1px solid #FF0000",
          padding: "16px",
          color: "#FF0000",
        },
        iconTheme: {
          primary: "#FF0000",
          secondary: "#FFFAEE",
        },
      });
    }
  };

  useEffect(() => {
    if (showEditModal && profileData) {
      const formattedDOB = profileData?.dob
        ? formatDateForInput(profileData.dob)
        : "";

      setEditForm({
        first_name: profileData?.first_name || "",
        last_name: profileData?.last_name || "",
        email: profileData?.email || "",
        mobile: profileData?.mobile || "",
        dob: formattedDOB,
      });
      setDob(formattedDOB);
    }
  }, [showEditModal, profileData]);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));

    if (name === "dob") {
      setDob(value);
    }
  };

  const handleModalClick = (e, closer) => {
    if (e.target.classList.contains("modal-overlay")) {
      closer();
    }
  };

  const validateProfileEditForm = () => {
    let formErrors = {};

    if (!editForm.first_name.trim()) {
      formErrors.first_name = "First name is required";
    } else if (!/^[A-Za-z\s]+$/.test(editForm.last_name)) {
      formErrors.first_name = "Only alphabets are allowed";
    }
    if (!editForm.last_name.trim()) {
      formErrors.last_name = "Last name is required";
    } else if (!/^[A-Za-z\s]+$/.test(editForm.last_name)) {
      formErrors.last_name = "Only alphabets are allowed";
    }
    if (!editForm.email.trim()) {
      formErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(editForm.email)) {
      formErrors.email = "Enter a valid email address";
    }
    if (!editForm.mobile.trim()) {
      formErrors.mobile = "Phone number is required";
    } else if (!/^\d{10}$/.test(editForm.mobile)) {
      formErrors.mobile = "Enter a valid 10-digit number";
    }
    // if (!editForm.dob) {
    //   formErrors.dob = "Date of birth is required";
    // }

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0; // true if no errors
  };
  const handleSubmitEditForm = (e) => {
    e.preventDefault();
    if (!validateProfileEditForm()) return; // stop if errors
    const updatedData = { ...editForm, dob };

    dispatch(
      updateUserProfile({
        id: profileData?.billingAddress?.id,
        data: updatedData,
      })
    ).then((res) => {
      // setShowEditModal(false);
      // setErrors({});
      if (res.meta.requestStatus === "fulfilled") {
        toast.success("Profile updated successfully!");
        setShowEditModal(false);
        setErrors({});
      } else {
        toast.error(res?.error?.message || "Something went wrong!");
      }
    });

    // dispatch(fetchUserProfile());
    setTimeout(() => {
      dispatch(fetchUserProfile());
    }, 1000);
  };

  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
        limit={1}
        toastStyle={{
          padding: "14px",
          color: "#000",
          fontSize: "14px",
          borderRadius: "8px",
        }}
      />
         <Breadcrumbs
          paths={[
            {
              label: 'My Account',
              to: "",
            }
          ]}
        />

      <div className="profile-container" style={{ paddingTop:"20px"}}>
     
        <div className="content-wrapper">

          
          <div className="profile-section-box"> 
            
          <div className="left-side-box">

           <div style={{ boxShadow:"0 2px 4px 0 rgba(0, 0, 0, .08)", padding:"10px", display:"flex", flexDirection:"column", alignItems:"center", gap:"10px", marginBottom:"20px", textAlign:"center"}}> 
              <div> <img src={profilepic} alt="Profile Picture" /> </div> 
              <div><span style={{ fontSize:"13px", color: "#9e9393"}}> Hello </span><br/> {profileData?.first_name} {profileData?.last_name} </div> 
          </div>

           <div className="left-profile-list" style={{ backgroundColor:"#f9f6f6"}}> 
                <a href="#" style={{ color:"#000"}}> Profile Details <span className="arrow-i"> <i class="bi bi-arrow-right-short"></i> </span> </a>
           </div>

            <div className="left-profile-list"> 
               <a href="/accounts"><i class="bi bi-person-circle iconsleft"></i>  My Profile </a>
            </div>
            <div className="left-profile-list"> 
                <a href="/accounts/orders"><i class="bi bi-box-fill iconsleft"></i>  Orders </a>
            </div>
              <div className="left-profile-list"> 
                 <a href="/accounts/addresses"><i class="bi bi-geo-fill iconsleft"></i>  Saved Addresses </a>  
            </div>
                <div className="left-profile-list">
                  <a href="#"> <i class="bi bi-box-arrow-in-left iconsleft"></i>  Logout </a>
                </div>
            </div>

          <div className="profile-section-001">
             <h3 style={{ fontSize:"20px"}}> Personal Information </h3>

             <div className="input-field"> 

            <div className="w-100 mt-2">
              <p className="txt_level">First Name</p>
              <div className="track_septor">
                {localLoading ? (
                  <Skeleton width={180} />
                ) : (
                  <>
                    {profileData?.first_name}
                  </>
                )}
              </div>
            </div>
            <div className="w-100 mt-2">
              <p className="txt_level">Last Name</p>
              <div className="track_septor">
                {localLoading ? (
                  <Skeleton width={180} />
                ) : (
                  <>
                   {profileData?.last_name}
                  </>
                )}
              </div>
            </div>

               </div> 

              <div className="input-field"> 
               <div className="w-100 mt-2">
              <p className="txt_level">Email Address</p>
              <div
                className="track_septor"
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  justifyContent: "space-between",
                }}
              >
                {localLoading ? (
                  <Skeleton width={200} />
                ) : (
                  <>
                    {profileData?.email}
                    {profileData?.email_verified === 0 ? (
                      <u
                        onClick={handleSendOtp}
                        style={{ fontWeight: "bold", cursor: "pointer" }}
                      >
                        Verify
                      </u>
                    ) : profileData?.email_verified === 1 ? (
                      <span className="track_ver">
                        <span style={{ position: "relative", right: "5px" }}>
                          <CircleCheckBig size={20} color="green" />
                        </span>
                        Email Verified
                      </span>
                    ) : null}
                  </>
                )}
              </div>
               </div>

                <div className="w-100 mt-2">
                  <p className="txt_level">Mobile Number</p>
                  <div className="track_septor">
                    {localLoading ? <Skeleton width={120} /> : profileData?.mobile}
                  </div>
                </div>
              </div>  

            <div className="mt-2">
              <p className="txt_level">Date of Birth</p>
              <div className="track_septor">
                {localLoading ? (
                  <Skeleton width={100} />
                ) : profileData?.dob ? (
                  new Date(profileData.dob).toLocaleDateString("en-GB").replaceAll("/", "-")
                ) : (
                  <span style={{ opacity: 0.6 }}>—</span> // placeholder to avoid squeezing
                )}
              </div>
            </div>

            <div >
              {localLoading ? (
                <Skeleton height={40} width={150} borderRadius={10} />
              ) : (
                <div className="edit-btn" onClick={() => setShowEditModal(true)}>
                  <p>
                    <span className="edit_text"> EDIT DETAILS </span>
                  </p>
                </div>
              )}
            </div>
            </div>

          </div>


        </div>

        {/* Edit Profile Modal */}
        {showEditModal && (
          <div
            className="modal-overlay"
            onClick={(e) => handleModalClick(e, () => setShowEditModal(false))} >
            <div className="side-modal">
              <div className="set_top_edit">
                <div>
                  <h3>Edit Profile</h3>
                </div>
                <div>
                  <button
                    className="close-btn"
                    onClick={() => {
                      setShowEditModal(false);
                      setErrors({});
                    }}
                  >
                    <IoMdClose />
                  </button>
                </div>
              </div>

              <form onSubmit={handleSubmitEditForm}>
                <label>
                  First Name
                  <input
                    name="first_name"
                    value={editForm.first_name}
                    onChange={handleEditChange}
                  />
                  {errors.first_name && (
                    <p className="error">{errors.first_name}</p>
                  )}
                </label>
                <label>
                  Last Name
                  <input
                    name="last_name"
                    value={editForm.last_name}
                    onChange={handleEditChange}
                  />
                  {errors.last_name && (
                    <p className="error">{errors.last_name}</p>
                  )}
                </label>
                <label>
                  Email
                  <input
                    name="email"
                    value={editForm.email}
                    onChange={handleEditChange}
                  />
                  {errors.email && <p className="error">{errors.email}</p>}
                </label>
                <label>
                  Phone
                  <input
                    name="mobile"
                    value={editForm.mobile}
                    onChange={handleEditChange}
                  />
                  {errors.mobile && <p className="error">{errors.mobile}</p>}
                </label>
                <label>
                  Date of Birth
                  <input
                    type="date"
                    name="dob"
                    value={dob}
                    onFocus={(e) => e.target.showPicker && e.target.showPicker()}
                    onChange={handleEditChange}
                  />
                  {errors.dob && <p className="error">{errors.dob}</p>}
                </label>
                <button type="submit">Save Changes</button>
              </form>
            </div>
          </div>
        )}
      </div>
      {showOtpModal && (
        <div className="login-prompt-backdrop profile-zindex" style={{ background: "rgb(0 0 0 / 88%)" }}>
          <div className="login-prompt-modal">
            <button className="close-btn-md" onClick={() => setShowOtpModal(false)}><X /></button>
            {/* <img src={logo} alt="Logo" className="modal-logo" /> */}
            <h2 className="modal-heading">Verify Your Email to Continue</h2>
            <p className="modal-subtext">
              A verification code has been sent to{" "} <strong>{profileData?.email}</strong>
            </p>
            <div className="verify-input-wrap mb-4">
              <input
                type="text"
                value={otp}
                onChange={(e) => {
                  const onlyNumbers = e.target.value.replace(/\D/g, ""); // remove non-digits
                  if (onlyNumbers.length <= 6) {
                    setOtp(onlyNumbers);
                  }
                }}
                placeholder="Enter OTP"
                maxLength={6}
                inputMode="numeric"
                required
              />

            </div>
            <button className="login-btn" onClick={handleVerifyOtp}>VERIFY</button>
            <p className="verify-resend">
              {canResendOtp ? (
                <>
                  Didn’t receive code?{" "}
                  <button onClick={handleSendOtp}>Resend Code</button>
                </>
              ) : (
                <span>
                  Resend available in <b>{otpTimer}s</b>
                </span>
              )}
            </p>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};
export default ProfilePage;
